import {z} from 'zod';

const boatCreateSchema = z.object({
    name: z.string()
        .min(1, "Jméno nemůže být prázdné")
        .max(50, "Jméno může mít maximálně 50 znaků"),
    boatNumber: z.string()
        .max(50, "Číslo lodi může mít maximálně 50 znaků")
        .optional().nullable(),
    sailNumber: z.string()
        .max(50, "Číslo na plachtě může mít maximálně 50 znaků")
        .optional().nullable(),
    raceNumber: z.number({
        required_error: "Závodní číslo je povinné",
        invalid_type_error: "Závodní číslo musí být platné číslo",
    })
        .positive("Startovní číslo musí být kladné")
        .int("Startovní číslo musí být celé číslo")
        .optional().nullable(),
    color: z.string()
        .max(50, "Barva může mít maximálně 50 znaků")
        .optional().nullable(),
    type: z.string()
        .max(50, "Typ může mít maximálně 50 znaků")
        .optional().nullable(),
    length: z.number({
        required_error: "Délka je povinné",
        invalid_type_error: "Délka musí být platné číslo",
    })
        .positive("Délka musí být kladná")
        .optional().nullable(),
    clubId: z.number({
        required_error: "Klub je povinný",
        invalid_type_error: "Klub musí být platné číslo",
    })
        .positive("Klub musí být vybrán")
        .optional().nullable(),
    categoryId: z.number({
        required_error: "Kategorie je povinná",
        invalid_type_error: "Kategorie musí být platné číslo",
    })
        .int("Kategorie musí být celé číslo")
        .positive("Kategorie musí být kladná")
});

type BoatCreateRequest = z.infer<typeof boatCreateSchema>;

export {boatCreateSchema, type BoatCreateRequest};